export enum UserTypes {
  ADMIN = 1,
  SCOREKEEPER = 2,
}
